export const ADD_LENSES_TYPE_SUCCESS = "ADD_LENSES_TYPE_SUCCESS";
export const LIST_ALL_LENSES_TYPES_SUCCESS = "LIST_ALL_LENSES_TYPES_REQUEST_SUCCESS";
export const UPDATE_LENSES_TYPE_SUCCESS = "UPDATE_LENSES_TYPE_SUCCESS";
export const LIST_ALL_LENSES_TYPES_REQUEST = "LIST_ALL_LENSES_TYPES_REQUEST";
export const LIST_ALL_LENSES_TYPES_FAILURE = "LIST_ALL_LENSES_TYPES_FAILURE";
export const DELETE_LENSES_TYPE_SUCCESS = "DELETE_LENSES_TYPE_SUCCESS";
export const CREATE_LENSES_TYPE_SUCCESS = "CREATE_LENSES_TYPE_SUCCESS";
